// extracted by mini-css-extract-plugin
export var active = "_28-d";
export var blink = "_28-e";
export var container = "_28-5";
export var controls = "_28-0";
export var controlsRight = "_28-1";
export var fakeCursor = "_28-c";
export var hidden = "_28-b";
export var quillContainerSmall = "_28-7";
export var quillEditor = "_28-6";
export var quillEditorSmall = "_28-8";
export var quillFormatButtons = "_28-a";
export var quillToolbar = "_28-9";
export var removePadding = "_28-2";
export var state = "_28-3";
export var stateTitle = "_28-4";